export const RIGHT = 0;
export const LEFT = 1;
export const BOTH = 2;
export const NONE = 3;

export const FIGURES= {
    3: ['. -', '- .'],
    4: ['. . -', '. - .', '- . .', '- -'],
    5: ['. . . -', '. . - .', '- - .', '. - -']
};
